export const AOP_PCT_LEGEND_ITEMS = [
  {
    key: "under",
    label: "Under-performing",
    range: "< 75%",
    color: "#dc3545",
  },
  {
    key: "attention",
    label: "Needs Attention",
    range: "75% - 89%",
    color: "#6c757d",
  },
  {
    key: "meeting",
    label: "Meeting/Exceeding",
    range: ">= 90%",
    color: "#198754",
  },
];

export function getAopActualPlanPctColor(pct) {
  if (pct == null || Number.isNaN(Number(pct))) return null;
  const n = Number(pct);
  if (n < 75) return AOP_PCT_LEGEND_ITEMS[0].color;
  if (n < 90) return AOP_PCT_LEGEND_ITEMS[1].color;
  return AOP_PCT_LEGEND_ITEMS[2].color;
}

export function getAopActualPlanPctCellStyle(pct, baseStyle = {}) {
  const color = getAopActualPlanPctColor(pct);
  if (!color) return baseStyle;
  return { ...baseStyle, color, fontWeight: 600 };
}
